import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Collapsible from '../../../components/Navigation/Collapsible';
import './style.scss';

export default class Company extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: require('./data/' + this.props.shortname + '.json').content,
        };
    }
    render() {
        const {
            type,
            description,
            website,
            img1,
            img2,
            img3,
            internationalSites,
        } = this.state.content;

        let websites = website;

        if (typeof website === 'string') {
            websites = [website];
        } else {
            websites = website;
        }

        const { shortname } = this.props;
        const collapsibleClosed = <div className="collapsibleClosed">International Sites +</div>;
        const collapsibleOpen = <div className="collapsibleOpen">International Sites -</div>;
        return (
            <Fragment>
                <ul className={'split ' + shortname}>
                    <li>
                        <img alt="" src={img1} />
                        {img2 ? <img alt="" className="second" src={img2} /> : null}
                    </li>
                    <li>
                        <div className="content-pad">
                            {type === 'Sports Fashion' ? (
                                <Link
                                    to="/our-group"
                                    title="Back to Sports Fashion"
                                    className="back"
                                >
                                    <i></i>Back to Sports Fashion
                                </Link>
                            ) : null}
                            {type === 'Outdoor Fashion' ? (
                                <Link
                                    to="/our-group/outdoors"
                                    title="Back to Outdoor"
                                    className="back"
                                >
                                    <i></i>Back to Outdoor
                                </Link>
                            ) : null}
                            <br />
                            <i
                                className={
                                    shortname === 'jd' || shortname === 'chausport'
                                        ? 'bigger'
                                        : null
                                }
                            ></i>
                            {shortname === 'sur' ? <i className="second"></i> : null}
                            <p
                                dangerouslySetInnerHTML={{
                                    __html: description,
                                }}
                            ></p>
                            {!!websites &&
                                websites.map((item, index) => (
                                    <a
                                        className="website"
                                        href={'https://' + item}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        title={this.props.request}
                                        key={index}
                                    >
                                        {item}
                                        <br />
                                    </a>
                                ))}
                            {!!internationalSites.length && (
                                <Collapsible
                                    trigger={collapsibleClosed}
                                    triggerWhenOpen={collapsibleOpen}
                                >
                                    {internationalSites.map((item, key) => (
                                        <a
                                            key={key}
                                            className="website collapsibleItem"
                                            href={'https://' + item}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {item}
                                        </a>
                                    ))}
                                </Collapsible>
                            )}
                        </div>
                        <img alt="" className="third" src={img3} />
                    </li>
                </ul>
                <div className="clear"></div>
            </Fragment>
        );
    }
}
